import { getUserRole } from "../../Services/Shared.service";
import { VendorAgent } from "../SideMenu/RouteMapping";

const userRole = getUserRole();

export const TaskHeadings1 = userRole.some((role) => role === VendorAgent) ? 
[
    {
        name: 'Booking No',
        value: 'megaCabsBookingNo'
    },
    {
        name: 'Booking Time',
        value: 'createdOn'
    },
    {
        name: 'Booking Via',
        value: 'bookingViaType'
    },
    {
        name: 'Booking By',
        value: 'createdBy'
    },
    {
        name: 'Booking Source',
        value: 'bookingSourceType'
    },
    {
        name: 'Intergrator',
        value: 'integratorName'
    },
    {
        name: 'Preferred cab',
        value: 'carType'
    },
    {
        name: 'Zone',
        value: 'pickUpZoneName'
    },
    {
        name: 'Pickup Date',
        value: 'pickUpDateTime'
    },
] : [
    {
        name: 'Booking No',
        value: 'megaCabsBookingNo'
    },
    {
        name: 'Booking Time',
        value: 'createdOn'
    },
    {
        name: 'Booking Via',
        value: 'bookingViaType'
    },
    {
        name: 'Booking By',
        value: 'createdBy'
    },
    {
        name: 'Booking Source',
        value: 'bookingSourceType'
    },
    {
        name: 'Intergrator',
        value: 'integratorName'
    },
    {
        name: 'Preferred cab',
        value: 'carType'
    },
    {
        name: 'Package',
        value: 'packageName'
    },
    {
        name: 'Zone',
        value: 'pickUpZoneName'
    },
    {
        name: 'Pickup Date',
        value: 'pickUpDateTime'
    },
]

export const TaskHeadings2 = userRole.some((role)=> role === VendorAgent) ?
[
    {
        name: 'Estimated KM',
        value: 'estimatedKm'
    },
    {
        name: 'Payment Type',
        value: 'paymentModeType'
    },
    {
        name: 'Agent',
        value: 'userName'
    },
    {
        name: 'Canceled Reason',
        value: 'cancelReason'
    },
    {
        name: 'Canceled By',
        value: 'canceledByUserType'
    },
    {
        name: 'Remarks',
        value: 'remark'
    },
] : [
    {
        name: 'Estimated KM',
        value: 'estimatedKm'
    },
    {
        name: 'Actual Estimate Fare',
        value: 'estimatedFare'
    },
    {
        name: 'Discount Amount',
        value: 'discountAmount'
    },
    {
        name: 'Estimated Fare',
        value: 'discountedEstimateFare'
    },
    {
        name: 'Payment Type',
        value: 'paymentModeType'
    },
    {
        name: 'Agent',
        value: 'userName'
    },
    {
        name: 'Canceled Reason',
        value: 'cancelReason'
    },
    {
        name: 'Canceled By',
        value: 'canceledByUserType'
    },
    {
        name: 'Remarks',
        value: 'remark'
    },
    {
        name: 'Vendor',
        value: 'aggregatorName'
    },
]


export const TaskHeadings3 = [
    {
        name: 'OTP',
        value: 'otp'
    }
]



export const TaskData1 = {
    booking_number: 'BNC922030082',
    booking_time: 'Sep 24,2022 1:30 PM',
    booking_via: 'Customer App',
    booking_by: 'Shylaja',
    intergrator: 'MegaCabs',
    preferred_cab: 'MUV',
    package: 'NO',
}

export const TaskData2 = {
    zone: 'Adhcnk',
    pickup_date: 'Sep 28, 2022 12:50 PM',
    start_time: 'Sep 28, 2022 12:50:46 PM',
    end_time: 'Sep 28, 2022 1:39:46 PM',
    distance: '17 km',
    fare: 'INR 239'
}